import { lazy } from 'react';

import lazyWithPreload from 'utils/lazyPreload';

const ScheduleCheckinModal = lazyWithPreload(
  () => import('modules/ElementaryCheckins/modals/ScheduleCheckinModal'),
);

const StudentListModal = lazy(
  () => import('modules/ElementaryCheckins/modals/StudentListModal'),
);

const ConflictedStudentListDrawer = lazy(
  () =>
    import(
      'modules/ElementaryCheckins/modals/ScheduleCheckinModal/components/ConflictedStudentListDrawer'
    ),
);

export default {
  SCHEDULE_CHECKIN_MODAL: ScheduleCheckinModal,
  STUDENT_LIST_MODAL: StudentListModal,
  CONFLICTED_STUDENT_LIST_DRAWER: ConflictedStudentListDrawer,
};
